import React, { useState, useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { PBPUTILS } from "../../config/API";
import jsPDF from 'jspdf';
import SuccessPage from '.././SuccessPage';

const StampsInventory = () => {
  // Get current date and calculate last month
  const getDefaultDate = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    let lastMonth = currentMonth - 1;
    let year = currentYear;

    if (lastMonth < 0) {
      lastMonth = 11;
      year = currentYear - 1;
    }

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return {
      month: monthNames[lastMonth],
      year: year.toString()
    };
  };

  const defaultDate = getDefaultDate();

  const [shipmentLocations, setShipmentLocations] = useState([
  { id: 1, name: '', value: '', sval: null }
]);

  const [locationOptions, setLocationOptions] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [loadingStartingCount, setLoadingStartingCount] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [showPdfDownload, setShowPdfDownload] = useState(false);
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const [submissionData, setSubmissionData] = useState(null);
  const [isBeginningInventoryEditable, setIsBeginningInventoryEditable] = useState(false);
  const [isVarianceExplanationRequired, setIsVarianceExplanationRequired] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState('');
  const [printedName, setPrintedName] = useState('');
  const [title, setTitle] = useState('');
  const [attachments, setAttachments] = useState([]);

  // Get taxpayer ID and business name from localStorage
  const [taxpayerId, setTaxpayerId] = useState('');
  const [businessName, setBusinessName] = useState('');

  const [formData, setFormData] = useState({
    distributor: '',
    month: defaultDate.month,
    year: defaultDate.year,
    expirationDate: '',
    reportMonth: defaultDate.month,
    reportYear: defaultDate.year,
    beginningInventory: '',
    stampsPurchased: '0',
    totalAvailable: '0',
    affixedStamps: '0',
    stampsDestroyed: '',
    adjustment: '',
    totalRemoved: '0',
    calculatedEndInventory: '0',
    fullRolls: '0',
    firstSetFullRolls: '0',
    firstSetStart: '',
    firstSetEnd: '',
    secondSetFullRolls: '0',
    secondSetStart: '',
    secondSetEnd: '',
    thirdSetFullRolls: '0',
    thirdSetStart: '',
    thirdSetEnd: '',
    partialRolls: '0',
    firstPartialRoll: '',
    firstPartialStart: '',
    firstPartialEnd: '',
    secondPartialRoll: '',
    secondPartialStart: '',
    secondPartialEnd: '',
    thirdPartialRoll: '',
    thirdPartialStart: '',
    thirdPartialEnd: '',
    looseStamps: '',
    positiveVariance: '',
    physicalEndTotal: '0',
    variance: '(0)',
    varianceExplanation: ''
  });

  const sigCanvas = useRef(null);
  const [isSigned, setIsSigned] = useState(false);
  const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 });
  const [currentDate] = useState(new Date().toLocaleDateString());

  // Month options for dropdown
  const monthOptions = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Year options (current year and previous few years)
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 6 }, (_, i) => (currentYear - 3 + i).toString());

  // Format month for API (convert to number with leading zero)
  const formatMonthForAPI = (monthName) => {
    const monthMap = {
      'January': '01', 'February': '02', 'March': '03', 'April': '04',
      'May': '05', 'June': '06', 'July': '07', 'August': '08',
      'September': '09', 'October': '10', 'November': '11', 'December': '12'
    };
    return monthMap[monthName] || '01';
  };

  // Get taxpayer ID and business name from localStorage on component mount
  useEffect(() => {
    const storedTaxpayerId = localStorage.getItem("selectedTaxPayer");
    const storedBusinessName = localStorage.getItem("selectedBusinessName");
    const storedExpirationDate = localStorage.getItem("businessLicenseExpirationDate");

    if (storedTaxpayerId) {
      setTaxpayerId(storedTaxpayerId);
    } else {
      setTaxpayerId('109');
    }

    if (storedBusinessName) {
      setBusinessName(storedBusinessName);
      setFormData(prev => ({
        ...prev,
        distributor: storedBusinessName
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        distributor: 'Black Canyon Distribution, LLC - PBPN License #41112-7777'
      }));
    }
    if (storedExpirationDate) {
      setFormData(prev => ({
        ...prev,
        expirationDate: storedExpirationDate
      }));
    }
  }, []);

  // Sync reportMonth and reportYear when month or year changes
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      reportMonth: prev.month,
      reportYear: prev.year
    }));
  }, [formData.month, formData.year]);

  // Fetch starting count from API for beginningInventory
  const fetchStartingCount = async () => {
    if (!taxpayerId) {
      return;
    }

    try {
      setLoadingStartingCount(true);
      const formattedMonth = formatMonthForAPI(formData.month);
      const apiUrl = PBPUTILS + `?taxpayer=${taxpayerId}&date=${formattedMonth}-${formData.year}&reporttype=Stamps&action=getStartCount`;
      console.log('Fetching starting count from URL:', apiUrl);
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.text();
      const count = parseInt(data.trim(), 10);
      console.log(count)

      if (!isNaN(count) && count > 0) {
        console.log(count)
        setFormData(prev => ({
          ...prev,
          beginningInventory: count.toString()
        }));
        setIsBeginningInventoryEditable(false);
      } else {
        setFormData(prev => ({
          ...prev,
          beginningInventory: '0'
        }));
        setIsBeginningInventoryEditable(true);
      }
    } catch (error) {
      console.error('Error fetching starting count:', error);
      setFormData(prev => ({
        ...prev,
        beginningInventory: '0'
      }));
      setIsBeginningInventoryEditable(true);
    } finally {
      setLoadingStartingCount(false);
    }
  };

  // Fetch starting count when month, year, or taxpayer ID changes
  useEffect(() => {
    if (taxpayerId) {
      fetchStartingCount();
    }
  }, [formData.month, formData.year, taxpayerId]);

  // Fetch location options from API
  const fetchLocationOptions = async () => {
    setLoadingLocations(true);
    try {
      const taxpayerId = localStorage.getItem("selectedTaxPayer") || '109';
      const apiUrl = `${PBPUTILS}?taxpayer=${taxpayerId}&action=getretailers`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === "success" && Array.isArray(result.data)) {
        const options = result.data.map(item => ({
          id: item.sval,
          name: item.dval,
          sval: item.sval,
          dval: item.dval
        }));

        setLocationOptions(options);

        // Don't set any default values - keep dropdowns empty
        setShipmentLocations([
  { id: 1, name: '', value: '', sval: null }
]);
      } else {
        throw new Error('Invalid API response structure');
      }
    } catch (error) {
      console.error('Error fetching location options:', error);
      const fallbackOptions = [
        { id: 100, name: 'Sample C Store', sval: 100, dval: 'Sample C Store' },
        { id: 107, name: 'One Stop', sval: 107, dval: 'One Stop' },
        { id: 108, name: 'Two Stop', sval: 108, dval: 'Two Stop' }
      ];
      setLocationOptions(fallbackOptions);
      // Don't set any default values even in fallback
      setShipmentLocations([
  { id: 1, name: '', value: '', sval: null }
]);
    } finally {
      setLoadingLocations(false);
    }
  };

  useEffect(() => {
    const taxPayer = localStorage.getItem("selectedTaxPayer");
    console.log('Current taxpayer ID:', taxPayer);
    fetchLocationOptions();
  }, []);

  // Initialize canvas size after component mounts
  useEffect(() => {
    const updateCanvasSize = () => {
      const container = document.getElementById('signature-container');
      if (container) {
        const width = container.clientWidth - 32;
        const height = 200;
        setCanvasSize({ width, height });

        if (sigCanvas.current) {
          const isEmpty = sigCanvas.current.isEmpty();
          if (!isEmpty) {
            const data = sigCanvas.current.toData();
            sigCanvas.current.clear();
            setTimeout(() => {
              if (sigCanvas.current) {
                sigCanvas.current.fromData(data);
              }
            }, 0);
          }
        }
      }
    };

    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);
    return () => window.removeEventListener('resize', updateCanvasSize);
  }, []);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleShipmentLocationChange = (id, value) => {
    setShipmentLocations(prev =>
      prev.map(location =>
        location.id === id ? { ...location, value } : location
      )
    );
  };

  const handleShipmentNameChange = (id, selectedName) => {
    const selectedOption = locationOptions.find(option => option.dval === selectedName);
    setShipmentLocations(prev =>
      prev.map(location =>
        location.id === id ? {
          ...location,
          name: selectedName,
          sval: selectedOption ? selectedOption.sval : null
        } : location
      )
    );
  };

  const addShipmentLocation = () => {
    const newId = Math.max(...shipmentLocations.map(loc => loc.id)) + 1;
    setShipmentLocations(prev => [
      ...prev,
      { id: newId, name: '', value: '', sval: null }
    ]);
  };

  const removeShipmentLocation = (id) => {
    if (shipmentLocations.length > 1) {
      setShipmentLocations(prev => prev.filter(location => location.id !== id));
    }
  };

  // Calculation functions
  const calculateTotalAffixedStamps = () => {
    const total = shipmentLocations.reduce((sum, location) => {
      const value = parseInt(location.value.replace(/,/g, '')) || 0;
      return sum + value;
    }, 0);
    return total.toLocaleString();
  };

  const calculateTotalAvailable = () => {
    const beginning = parseInt(formData.beginningInventory.replace(/,/g, '')) || 0;
    const purchased = parseInt(formData.stampsPurchased.replace(/,/g, '')) || 0;
    const total = beginning + purchased;
    return total.toLocaleString();
  };

  const calculateTotalRemoved = () => {
    const affixed = parseInt(formData.affixedStamps.replace(/,/g, '')) || 0;
    const destroyed = parseInt(formData.stampsDestroyed.replace(/,/g, '')) || 0;
    const adjustment = parseInt(formData.adjustment.replace(/,/g, '')) || 0;
    const total = affixed + destroyed + adjustment;
    return total.toLocaleString();
  };

  const calculateEndInventory = () => {
    const beginning = parseInt(formData.beginningInventory.replace(/,/g, '')) || 0;
    const purchased = parseInt(formData.stampsPurchased.replace(/,/g, '')) || 0;
    const affixed = parseInt(formData.affixedStamps.replace(/,/g, '')) || 0;
    const destroyed = parseInt(formData.stampsDestroyed.replace(/,/g, '')) || 0;
    const adjustment = parseInt(formData.adjustment.replace(/,/g, '')) || 0;
    const totalAvailable = beginning + purchased;
    const totalRemoved = affixed + destroyed + adjustment;
    const endInventory = totalAvailable - totalRemoved;
    return endInventory.toLocaleString();
  };

  const calculateVariance = () => {
    const calculated = parseInt(formData.calculatedEndInventory.replace(/,/g, '')) || 0;
    const physical = parseInt(formData.physicalEndTotal.replace(/,/g, '')) || 0;
    const variance = physical - calculated;

    if (variance === 0) {
      return '0';
    } else if (variance < 0) {
      return `(${Math.abs(variance).toLocaleString()})`;
    } else {
      return variance.toLocaleString();
    }
  };

  const calculateFullRolls = (start, end) => {
    if (!start || !end) return 0;
    const startNum = parseInt(start.replace(/,/g, ''));
    const endNum = parseInt(end.replace(/,/g, ''));
    if (isNaN(startNum) || isNaN(endNum)) return 0;
    return endNum - startNum + 1;
  };

  const calculateTotalFullRolls = () => {
    const firstSet = parseInt(formData.firstSetFullRolls) || 0;
    const secondSet = parseInt(formData.secondSetFullRolls) || 0;
    const thirdSet = parseInt(formData.thirdSetFullRolls) || 0;
    return (firstSet + secondSet + thirdSet) * 15000;
  };

  const calculatePartialRolls = () => {
    const firstPartialEndNum = parseInt(formData.firstPartialEnd.replace(/,/g, '')) || 0;
    const secondPartialEndNum = parseInt(formData.secondPartialEnd.replace(/,/g, '')) || 0;
    const thirdPartialEndNum = parseInt(formData.thirdPartialEnd.replace(/,/g, '')) || 0;
    const looseStampsNum = parseInt(formData.looseStamps.replace(/,/g, '')) || 0;
    const total = firstPartialEndNum + secondPartialEndNum + thirdPartialEndNum + looseStampsNum;
    return total.toLocaleString();
  };

  const calculatePhysicalEndTotal = () => {
    const fullRolls = parseInt(formData.fullRolls.replace(/,/g, '')) || 0;
    const partialRolls = parseInt(formData.partialRolls.replace(/,/g, '')) || 0;
    const total = fullRolls + partialRolls;
    return total.toLocaleString();
  };

  // Auto-calculate when dependent values change
  useEffect(() => {
    const totalAffixed = calculateTotalAffixedStamps();
    const totalAvailable = calculateTotalAvailable();
    const totalRemoved = calculateTotalRemoved();
    const endInventory = calculateEndInventory();

    setFormData(prev => ({
      ...prev,
      affixedStamps: totalAffixed,
      totalAvailable: totalAvailable,
      totalRemoved: totalRemoved,
      calculatedEndInventory: endInventory
    }));
  }, [
    shipmentLocations,
    formData.beginningInventory,
    formData.stampsPurchased,
    formData.stampsDestroyed,
    formData.adjustment,
    formData.affixedStamps
  ]);

  useEffect(() => {
    const partialRolls = calculatePartialRolls();
    setFormData(prev => ({
      ...prev,
      partialRolls: partialRolls
    }));
  }, [
    formData.firstPartialEnd,
    formData.secondPartialEnd,
    formData.thirdPartialEnd,
    formData.looseStamps
  ]);

  useEffect(() => {
    const physicalEndTotal = calculatePhysicalEndTotal();
    setFormData(prev => ({
      ...prev,
      physicalEndTotal: physicalEndTotal
    }));
  }, [formData.fullRolls, formData.partialRolls]);

  useEffect(() => {
    const variance = calculateVariance();
    const varianceValue = parseInt(variance.replace(/[(),]/g, '')) || 0;
    const isNonZeroVariance = varianceValue !== 0;

    setIsVarianceExplanationRequired(isNonZeroVariance);

    setFormData(prev => ({
      ...prev,
      variance: variance
    }));
  }, [formData.calculatedEndInventory, formData.physicalEndTotal]);

  useEffect(() => {
    const firstSetFullRolls = calculateFullRolls(formData.firstSetStart, formData.firstSetEnd);
    const secondSetFullRolls = calculateFullRolls(formData.secondSetStart, formData.secondSetEnd);
    const thirdSetFullRolls = calculateFullRolls(formData.thirdSetStart, formData.thirdSetEnd);

    setFormData(prev => ({
      ...prev,
      firstSetFullRolls: firstSetFullRolls.toString(),
      secondSetFullRolls: secondSetFullRolls.toString(),
      thirdSetFullRolls: thirdSetFullRolls.toString()
    }));
  }, [
    formData.firstSetStart, formData.firstSetEnd,
    formData.secondSetStart, formData.secondSetEnd,
    formData.thirdSetStart, formData.thirdSetEnd
  ]);

  useEffect(() => {
    const totalFullRolls = calculateTotalFullRolls();
    setFormData(prev => ({
      ...prev,
      fullRolls: totalFullRolls.toString()
    }));
  }, [formData.firstSetFullRolls, formData.secondSetFullRolls, formData.thirdSetFullRolls]);

  const clearSignature = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
      setIsSigned(false);
    }
  };

  const handleSignatureBegin = () => {
    setIsSigned(true);
  };

  const handleSignatureEnd = () => {
    // Signature completion logic
  };

  // Helper function to convert base64 data URL to File object
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

// Generate PDF function - accepts optional signature override (use when generating for send, since setState is async)
const generatePDF = (signatureDataURLOverride) => {
  const pdf = new jsPDF();
  const signatureToUse = signatureDataURLOverride !== undefined ? signatureDataURLOverride : signatureDataURL;

  const formatAmount = (value) => {
    if (value === null || value === undefined) return '0';
    const s = String(value).replace(/,/g, '').trim();
    if (s === '') return '0';
    const num = Number(s);
    if (isNaN(num)) return String(value);
    if (s.includes('.')) {
      const decimals = s.split('.')[1].length;
      return num.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }
    return num.toLocaleString();
  };

  // Set font and colors
  pdf.setFont('helvetica');
  pdf.setTextColor(0, 0, 0); // #840028

  // Header Section
  pdf.setFontSize(16);
  pdf.text('Monthly Distributor Report', 105, 20, { align: 'center' });

  pdf.setFontSize(12);
  pdf.text('Prairie Band Potawatomi Tax Commission', 105, 30, { align: 'center' });
  pdf.text('16281 Q Road', 105, 36, { align: 'center' });
  pdf.text('Mayetta, KS 66509', 105, 42, { align: 'center' });

  pdf.setFontSize(10);
  pdf.text('Reports and Payment due on the 10th of each Month', 105, 50, { align: 'center' });

  // Distributor Information
  pdf.setFontSize(12);
  pdf.setTextColor(0, 0, 0);
  pdf.text('Distributor Information:', 20, 65);
  pdf.setFontSize(10);
  pdf.text(`Distributor: ${formData.distributor}`, 20, 72);
  pdf.text(`Month: ${formData.month} ${formData.year}`, 20, 78);
  pdf.text(`PBPN Tribal Distributor License Expiration Date: ${formData.expirationDate}`, 20, 84);

  if (taxpayerId) {
    pdf.text(`Taxpayer ID: ${taxpayerId}`, 20, 90);
  }
  // if (businessName) {
  //   pdf.text(`Business: ${businessName}`, 20, 96);
  // }

  // Stamp Inventory Section
  pdf.setFontSize(12);
  pdf.setTextColor(0, 0, 0);
  pdf.text('Distributor Un-Affixed Stamp Inventory', 20, 110);

  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  let yPosition = 120;

  // Stamp Inventory Data with proper labels
  const stampData = [
    { label: '1. Beginning 1st of the month inventory of Un-affixed Stamps', value: formData.beginningInventory },
    { label: '2. # of Stamps Purchased from PBPN', value: formData.stampsPurchased },
    { label: '3. Total unaffixed stamps available (Line 1 + Line 2)', value: formData.totalAvailable },
    { label: '4. # of Affixed Stamped Packs shipped', value: formData.affixedStamps },
    { label: '5. # of Stamps destroyed by process', value: formData.stampsDestroyed },
    { label: '6. Adjustment', value: formData.adjustment },
    { label: '7. Total Stamps removed from Inventory (Line 4 + 5 + 6)', value: formData.totalRemoved },
    { label: '8. "Calculated" End of Month Inventory of Un-affixed Stamps', value: formData.calculatedEndInventory }
  ];

  stampData.forEach((item, index) => {
    if (yPosition > 270) {
      pdf.addPage();
      yPosition = 20;
    }
    pdf.text(item.label, 20, yPosition);
    pdf.text(formatAmount(item.value), 180, yPosition, { align: 'right' });
    yPosition += 8;
    
    // After line 4, add the shipment locations as sub-items
    if (index === 3) { // This is line 4 (index 3 in zero-based array)
      // Add shipment locations as sub-items of line 4
      shipmentLocations.forEach((location, locIndex) => {
        if (yPosition > 270) {
          pdf.addPage();
          yPosition = 20;
        }
        const letter = String.fromCharCode(97 + locIndex); // a, b, c, etc.
        
        // Only show if location has a name and value
        if (location.name && (location.value || location.value === '0')) {
          pdf.text(`  4${letter}. ${location.name}: ${location.value || '0'}`, 25, yPosition);
          yPosition += 6;
        }
      });
      
      // Add a little extra space after the shipment locations
      if (shipmentLocations.some(loc => loc.name && (loc.value || loc.value === '0'))) {
        yPosition += 2;
      }
    }
  });

  // Physical Inventory Section
  if (yPosition > 250) {
    pdf.addPage();
    yPosition = 20;
  }

  pdf.setFontSize(12);
  pdf.setTextColor(0, 0, 0);
  pdf.text('Physical Inventory Details', 20, yPosition);
  yPosition += 10;

  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);

  // Full Rolls
  pdf.text('9. "Physical" End of the Month un-affixed Stamps - Full Rolls', 20, yPosition);
  pdf.text(formatAmount(formData.fullRolls), 180, yPosition, { align: 'right' });
  yPosition += 8;

  // Full Roll Details
  if (formData.firstSetStart && formData.firstSetEnd) {
    pdf.text(`  9.1 First set "Full" Roll series: ${formData.firstSetStart} - ${formData.firstSetEnd} (${formData.firstSetFullRolls} rolls)`, 25, yPosition);
    yPosition += 6;
  }
  if (formData.secondSetStart && formData.secondSetEnd) {
    pdf.text(`  9.2 Second set "Full" Roll series: ${formData.secondSetStart} - ${formData.secondSetEnd} (${formData.secondSetFullRolls} rolls)`, 25, yPosition);
    yPosition += 6;
  }
  if (formData.thirdSetStart && formData.thirdSetEnd) {
    pdf.text(`  9.3 Third set "Full" Roll series: ${formData.thirdSetStart} - ${formData.thirdSetEnd} (${formData.thirdSetFullRolls} rolls)`, 25, yPosition);
    yPosition += 6;
  }

  // Partial Rolls
  yPosition += 4;
  pdf.text('10. "Physical" End of the Month un-affixed Stamps - Partial Roll Series', 20, yPosition);
  pdf.text(formatAmount(formData.partialRolls), 180, yPosition, { align: 'right' });
  yPosition += 8;

  // Partial Roll Details
  if (formData.firstPartialStart && formData.firstPartialEnd) {
    pdf.text(`  10.1 First Partial Roll: ${formData.firstPartialStart} - ${formData.firstPartialEnd}`, 25, yPosition);
    yPosition += 6;
  }
  if (formData.secondPartialStart && formData.secondPartialEnd) {
    pdf.text(`  10.2 Second Partial Roll: ${formData.secondPartialStart} - ${formData.secondPartialEnd}`, 25, yPosition);
    yPosition += 6;
  }
  if (formData.thirdPartialStart && formData.thirdPartialEnd) {
    pdf.text(`  10.3 Third Partial Roll: ${formData.thirdPartialStart} - ${formData.thirdPartialEnd}`, 25, yPosition);
    yPosition += 6;
  }
  if (formData.looseStamps) {
    pdf.text(`  10.4 Loose Stamps: ${formatAmount(formData.looseStamps)}`, 25, yPosition);
    yPosition += 6;
  }
  if (formData.positiveVariance) {
    pdf.text(`  10.5 Positive Variance: ${formatAmount(formData.positiveVariance)}`, 25, yPosition);
    yPosition += 6;
  }

  // Totals and Variance
  yPosition += 4;
  pdf.text('11. "Physical" End of Month Total # un-Affixed Stamps in inventory:', 20, yPosition);
  pdf.text(formatAmount(formData.physicalEndTotal), 180, yPosition, { align: 'right' });
  yPosition += 8;

  pdf.text('Variance:', 20, yPosition);
  pdf.text(formatAmount(formData.variance), 180, yPosition, { align: 'right' });
  yPosition += 8;

  // Variance Explanation (if provided)
  if (formData.varianceExplanation && formData.varianceExplanation.trim() !== '') {
    pdf.text('Variance Explanation:', 20, yPosition);
    yPosition += 8;

    // Split the explanation into multiple lines if it's too long
    const explanationLines = pdf.splitTextToSize(formData.varianceExplanation, 170);
    explanationLines.forEach((line) => {
      if (yPosition > 270) {
        pdf.addPage();
        yPosition = 20;
      }
      pdf.text(line, 25, yPosition);
      yPosition += 6;
    });
    yPosition += 4;
  }

  // Add a new page for signature and certification
  if (yPosition > 180) {
    pdf.addPage();
    yPosition = 20;
  }




  // Signature Section
  pdf.setFontSize(12);
  pdf.setTextColor(0, 0, 0);
  pdf.text('Signature and Certification', 105, yPosition, { align: 'center' });
  yPosition += 15;


     // Certification Text
  pdf.setFontSize(10);
  pdf.text('I certify that I am a duly authorized owner, partner, director, officer or', 20, yPosition);
  yPosition += 6;
  pdf.text('representative of the licensee and that the statements made herein are true', 20, yPosition);
  yPosition += 6;
  pdf.text('and correct to the best of my knowledge.', 20, yPosition);
  yPosition += 15;

  // Add signature image if available
  if (signatureToUse) {
    try {
      // Add signature image to PDF
      pdf.addImage(signatureToUse, 'PNG', 20, yPosition, 80, 40);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 0, 0);
      pdf.text('Signature:', 20, yPosition - 5);
      yPosition += 50;
    } catch (error) {
      console.error('Error adding signature to PDF:', error);
      // Fallback: show signature text
      pdf.setFontSize(10);
      pdf.setTextColor(0, 0, 0);
      pdf.text('Signature: Provided (technical issue with image)', 20, yPosition);
      yPosition += 10;
    }
  } else {
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);
    pdf.text('Signature: Not available in this PDF copy', 20, yPosition);
    yPosition += 10;
  }

  // Printed Name and Title
  pdf.text(`Printed Name: ${printedName}`, 20, yPosition);
  yPosition += 6;
  pdf.text(`Title: ${title}`, 20, yPosition);
  yPosition += 8;

  // Date Signed
  pdf.text(`Date Signed: ${currentDate}`, 20, yPosition);
  yPosition += 15;

 


  return pdf;
};

  // Function to handle PDF download from SuccessPage
  const handleDownloadPDF = () => {
    const pdf = generatePDF();
    const fileName = `Stamps_Report_${formData.month}_${formData.year}_${taxpayerId || 'unknown'}.pdf`;
    pdf.save(fileName);
  };

  // Function to handle back to form
  const handleBackToForm = () => {
    setShowSuccessScreen(false);
  };

  // Add this helper function to convert PDF to Blob
  const pdfToBlob = (pdf) => {
    const pdfOutput = pdf.output('blob');
    return pdfOutput;
  };

  // File upload handlers
  const handleAttachmentChange = (event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    setAttachments((prev) => {
      const existingNames = new Set(prev.map((f) => f.name));
      const newFiles = files.filter((f) => !existingNames.has(f.name));
      return [...prev, ...newFiles];
    });

    // Allow re-selecting the same file names again later
    event.target.value = '';
  };

  const handleRemoveAttachment = (indexToRemove) => {
    setAttachments((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  // Then modify your handleSubmit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isSigned || (sigCanvas.current && sigCanvas.current.isEmpty())) {
      alert('Please provide a signature before submitting the report.');
      return;
    }

    if (!printedName.trim()) {
      alert('Please enter your printed name.');
      return;
    }

    if (!title.trim()) {
      alert('Please enter your title.');
      return;
    }

    if (isVarianceExplanationRequired && !formData.varianceExplanation.trim()) {
      alert('Variance explanation is required when there is a variance. Please explain the reason for the variance.');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');
    setShowPdfDownload(false);
    setShowSuccessScreen(false);
    

    try {
      const signatureDataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
      setSignatureDataURL(signatureDataURL);

      const signatureFile = dataURLtoFile(signatureDataURL, 'signature.png');

      // Generate PDF with signature passed in (state update is async, so state would still be old here)
      const pdf = generatePDF(signatureDataURL);

      // Convert PDF to Blob and then to File
      const pdfBlob = pdfToBlob(pdf);
      const pdfFile = new File([pdfBlob], `Stamps_Report_${formData.month}_${formData.year}_${taxpayerId || 'unknown'}.pdf`, {
        type: 'application/pdf'
      });


      const submissionData = {
        beginningInventory: parseInt(formData.beginningInventory.replace(/,/g, '')) || 0,
        stampsPurchased: parseInt(formData.stampsPurchased.replace(/,/g, '')) || 0,
        totalAvailable: parseInt(formData.totalAvailable.replace(/,/g, '')) || 0,
        affixedStamps: parseInt(formData.affixedStamps.replace(/,/g, '')) || 0,
        stampsDestroyed: parseInt(formData.stampsDestroyed.replace(/,/g, '')) || 0,
        adjustment: parseInt(formData.adjustment.replace(/,/g, '')) || 0,
        totalRemoved: parseInt(formData.totalRemoved.replace(/,/g, '')) || 0,
        calculatedEndInventory: parseInt(formData.calculatedEndInventory.replace(/,/g, '')) || 0,

        shipments: shipmentLocations.map(location => ({
          location: location.sval,
          stampsAffixed: parseInt(location.value.replace(/,/g, '')) || 0
        })),

        fullRollsTotal: parseInt(formData.fullRolls.replace(/,/g, '')) || 0,
        fullRollSets: [
          {
            set: 1,
            startSeries: formData.firstSetStart,
            endSeries: formData.firstSetEnd,
            rollCount: parseInt(formData.firstSetFullRolls) || 0
          },
          {
            set: 2,
            startSeries: formData.secondSetStart,
            endSeries: formData.secondSetEnd,
            rollCount: parseInt(formData.secondSetFullRolls) || 0
          },
          {
            set: 3,
            startSeries: formData.thirdSetStart,
            endSeries: formData.thirdSetEnd,
            rollCount: parseInt(formData.thirdSetFullRolls) || 0
          }
        ],

        partialRollsTotal: parseInt(formData.partialRolls.replace(/,/g, '')) || 0,
        partialRolls: [
          {
            roll: 1,
            startSeries: formData.firstPartialStart,
            endSeries: formData.firstPartialEnd,
            stampsCount: parseInt(formData.firstPartialRoll) || 0
          },
          {
            roll: 2,
            startSeries: formData.secondPartialStart,
            endSeries: formData.secondPartialEnd,
            stampsCount: parseInt(formData.secondPartialRoll) || 0
          },
          {
            roll: 3,
            startSeries: formData.thirdPartialStart,
            endSeries: formData.thirdPartialEnd,
            stampsCount: parseInt(formData.thirdPartialRoll) || 0
          }
        ],

        looseStamps: parseInt(formData.looseStamps.replace(/,/g, '')) || 0,
        positiveVariance: parseInt(formData.positiveVariance.replace(/,/g, '')) || 0,
        physicalEndTotal: parseInt(formData.physicalEndTotal.replace(/,/g, '')) || 0,

        varianceAmount: parseInt(formData.variance.replace(/[(),]/g, '')) * (formData.variance.includes('(') ? -1 : 1) || 0,
        varianceExplanation: formData.varianceExplanation,

        printedName: printedName,
        title: title,
        signatureDate: currentDate,
        submissionTimestamp: new Date().toISOString()
      };

      setSubmissionData(submissionData);
      
      const formDataToSend = new FormData();
      formDataToSend.append('Body', JSON.stringify(submissionData));
      formDataToSend.append('reportMonth', formData.reportMonth);
      formDataToSend.append('reportYear', formData.reportYear);
      formDataToSend.append('Signature', signatureFile, 'signature.png');

      // Append PDF to FormData with key name "PDF"
      formDataToSend.append('PDF', pdfFile, `Stamps_Report_${formData.month}_${formData.year}_${taxpayerId || 'unknown'}.pdf`);

      // Append any optional supporting document uploads
      attachments.forEach((file, index) => {
        formDataToSend.append('Receipts', file);
        // Append file type with index to match files with their types
        // formDataToSend.append(`ReceiptsType_${index}`, 'Invoice');
      });
     

      const apiUrl = `${PBPUTILS}?taxpayer=${taxpayerId}&reporttype=Stamps`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formDataToSend
      });

      const responseText = await response.text();
      console.log('API Response:', responseText);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}, message: ${responseText}`);
      }

      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        console.warn('Response is not valid JSON, treating as plain text:', responseText);
        if (responseText.trim() === 'True') {
          setSubmitMessage('success');
          setShowPdfDownload(true);
          setShowSuccessScreen(true);
          return;
        } else {
          throw new Error(`Unexpected response from server: ${responseText}`);
        }
      }

      if (result && result.Status === 'Success') {
        setSubmitMessage('success');
        setShowPdfDownload(true);
        setShowSuccessScreen(true);
        return;
      } else if (result && result.Status === 'Error') {
        alert(result.Message || 'An error occurred while submitting the report.');
        setSubmitMessage('error');
        return;
      } else {
        throw new Error('Unexpected response format from server');
      }

    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitMessage('error');

      let errorMessage = 'Failed to submit report. Please try again.';
      if (error.message.includes('Invalid Taxpayer')) {
        errorMessage = 'Invalid Taxpayer ID. Please check your taxpayer information.';
      } else if (error.message.includes('Record already exist')) {
        errorMessage = error.message;
      } else if (error.message.includes('HTTP error')) {
        errorMessage = `Server error: ${error.message}`;
      } else if (error.message.includes('Unexpected response')) {
        errorMessage = error.message;
      }

      alert(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Get available options for dropdown (options not already selected)
  const getAvailableOptions = (currentLocationId) => {
    const usedNames = shipmentLocations
      .filter(location => location.id !== currentLocationId)
      .map(location => location.name);

    return locationOptions.filter(option => !usedNames.includes(option.dval));
  };

  // Prepare report details for SuccessPage
  const reportDetails = {
    'Report Type': 'Stamps Inventory',
    'Taxpayer ID': taxpayerId,
    'Business': businessName,
    'Period': `${formData.month} ${formData.year}`,
    'Submitted': currentDate,
    
  };

  // If showing success screen, render the SuccessPage component
  if (showSuccessScreen) {
    return (
      <SuccessPage
        title="Stamps Inventory Report Submitted Successfully!"
        subtitle={`Your stamps inventory report for ${formData.month} ${formData.year} has been successfully submitted.`}
        downloadButtonText="Download Stamps Report PDF"
        backButtonText="Back to Home"
        onDownload={handleDownloadPDF}
        onBack={handleBackToForm}
        reportDetails={reportDetails}
        contactInfo={{
          phone: "(785) 966-3060",
          email: "taxcommission@pbpnation.org",
          department: "Prairie Band Potawatomi Tax Commission"
        }}
      >
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
          <h3 className="font-semibold text-green-800 mb-2">Important Notes:</h3>
          <ul className="text-sm text-green-700 space-y-1">
            <li>• The report covers stamps inventory for the specified period</li>
            <li>• Ensure all variance explanations are documented</li>
            <li>• Contact us if you need to make any corrections</li>
          </ul>
        </div>
      </SuccessPage>
    );
  }

  // Main form return
  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 bg-white">
      {/* Header Section */}
      <div className="text-center mb-6 sm:mb-8 border-b-2 border-[#840028] pb-4 sm:pb-6">
        <h1 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-[#840028]">Monthly Distributor Report</h1>
        <div className="font-bold mb-2 text-[#840028] text-sm sm:text-base">
          <div>Prairie Band Potawatomi Tax Commission</div>
          <div>16281 Q Road</div>
          <div>Mayetta, KS 66509</div>
        </div>
        <div className="italic mb-2 text-[#840028] text-sm sm:text-base">
          Reports and Payment due on the 10th of each Month
        </div>
        {taxpayerId && (
          <div className="text-xs sm:text-sm text-gray-600 mt-2 flex flex-col sm:flex-row sm:items-center sm:justify-center gap-1 sm:gap-4">
            <span>Taxpayer ID: <strong>{taxpayerId}</strong></span>
            {businessName && (
              <span>Business: <strong>{businessName}</strong></span>
            )}
          </div>
        )}

        {/* Submission Status Message */}
        {submitMessage === 'success' && !showSuccessScreen && (
          <div className="mt-4 p-3 sm:p-4 bg-green-100 border border-green-400 text-green-700 rounded">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="flex items-center justify-center sm:justify-start">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-semibold">Report submitted successfully!</span>
              </div>
              {showPdfDownload && (
                <button
                  onClick={() => setShowSuccessScreen(true)}
                  className="bg-[#840028] hover:bg-[#6a0020] text-white font-bold py-2 px-4 rounded transition duration-200 text-sm"
                >
                  Download PDF
                </button>
              )}
            </div>
          </div>
        )}
        {submitMessage === 'error' && (
          <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded text-sm">
            Failed to submit report. Please try again.
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        {/* Distributor Information Section*/}
        <div className="border border-gray-300 p-3 sm:p-4 mb-4 sm:mb-6">
          {/* Distributor Row - At Top */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 mb-3">
            <label className="font-bold sm:w-48 sm:mr-4 text-[#840028] text-sm sm:text-base">Distributor:</label>
            <div className="px-3 py-2 border border-gray-300 bg-gray-50 sm:min-w-80 text-sm sm:text-base">
              {formData.distributor}
            </div>
          </div>

          {/* Month and Year Row */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0 mb-3">
            <label className="font-bold sm:w-48 sm:mr-4 text-[#840028] text-sm sm:text-base">Month:</label>
            <select
              value={formData.month}
              onChange={(e) => handleInputChange('month', e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white sm:min-w-32 sm:mr-8 text-sm sm:text-base"
            >
              {monthOptions.map(month => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>

            <label className="font-bold sm:w-12 sm:mr-4 text-[#840028] text-sm sm:text-base">Year:</label>
            <select
              value={formData.year}
              onChange={(e) => handleInputChange('year', e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white sm:min-w-20 text-sm sm:text-base"
            >
              {yearOptions.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

          <div className="hidden">
            <input
              type="text"
              value={formData.reportMonth}
              readOnly
            />
            <input
              type="text"
              value={formData.reportYear}
              readOnly
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0">
            <label className="font-bold sm:w-48 sm:mr-4 text-[#840028] text-sm sm:text-base">PBPN Tribal Distributor License Expiration Date:</label>
            <div className="px-3 py-2 border border-gray-300 bg-gray-50 sm:min-w-32 text-sm sm:text-base">
              {formData.expirationDate}
            </div>
          </div>
        </div>

        {/* Distributor Un-Affixed Stamp Inventory Section */}
        <div className="border border-gray-300 p-3 sm:p-4 mb-4 sm:mb-6 overflow-x-auto">
          <h2 className="text-lg font-bold mb-3 sm:mb-4 border-b border-[#840028] pb-2 text-[#840028]">
            Distributor Un-Affixed Stamp Inventory
          </h2>

          <div className="min-w-[800px] sm:min-w-full">
            <div className="grid grid-cols-[auto,1fr,auto,auto] gap-2 mb-4 text-sm sm:text-base">
              {/* Header */}
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm"># of Stamps</div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm">Distributor Un-Affixed Stamp Inventory</div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm"># of Stamps</div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm"></div>

              {/* Row 1 */}
              <div className="p-2 border-b border-gray-200">1.</div>
              <div className="p-2 border-b border-gray-200">Beginning 1st of the month inventory of Un-affixed Stamps (last month's line 10)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">24.</div>
              <div className="p-2 border-b border-gray-200">
                <div className="relative">
                  <input
                    min="0"
                    type="number"
                    value={formData.beginningInventory}
                    readOnly={!isBeginningInventoryEditable}
                    onChange={(e) => handleInputChange('beginningInventory', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                  />
                  {loadingStartingCount && (
                    <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                    </div>
                  )}
                </div>
                {loadingStartingCount && (
                  <span className="text-xs text-blue-600">Loading starting count...</span>
                )}
              </div>

              {/* Row 2 */}
              <div className="p-2 border-b border-gray-200">2.</div>
              <div className="p-2 border-b border-gray-200"># of Stamps Purchased from PBPN (Line 14, page 2)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">25.</div>
              <div className="p-2 border-b border-gray-200">
                <input
                  min="0"
                  type="number"
                  value={formData.stampsPurchased}
                  onChange={(e) => handleInputChange('stampsPurchased', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                />
              </div>

              {/* Row 3 */}
              <div className="p-2 border-b border-gray-200">3.</div>
              <div className="p-2 border-b border-gray-200">Total unaffixed stamps available (Line 1 + Line 2) (or ST Line 1 + 2)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">26.</div>
              <div className="p-2 border-b border-gray-200 bg-gray-50 text-right pr-3 text-sm">
                {formData.totalAvailable}
              </div>

              {/* Row 4 */}
              <div className="p-2 border-b border-gray-200">4.</div>
              <div className="p-2 border-b border-gray-200"># of Affixed Stamped Packs shipped to (4a + 4b): "New" Stamps</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">27.</div>
              <div className="p-2 border-b border-gray-200 bg-gray-50 text-right pr-3 text-sm">
                {formData.affixedStamps}
              </div>

              {/* Dynamic Shipment Locations */}
              <div className="col-span-4 ml-4 sm:ml-8">
                <div className="space-y-2">
                  {shipmentLocations.map((location, index) => {
                    const letter = String.fromCharCode(96 + index + 1);
                    const availableOptions = getAvailableOptions(location.id);

                    return (
                      <div key={location.id} className="grid grid-cols-[auto,1fr,auto,auto] gap-2 items-center">
                        <div className="p-2 border-b border-gray-200">4{letter}.</div>
                        <div className="p-2 border-b border-gray-200">
                          <select
                            value={location.name}
                            onChange={(e) => handleShipmentNameChange(location.id, e.target.value)}
                            className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] bg-white text-sm"
                            disabled={loadingLocations}
                          >
                            {loadingLocations ? (
                              <option>Loading locations...</option>
                            ) : (
                              <>
                                <option value="">Select a location</option>
                                {availableOptions.map(option => (
                                  <option key={option.sval} value={option.dval}>
                                    {option.dval}
                                  </option>
                                ))}
                                {!availableOptions.some(opt => opt.dval === location.name) && location.name && (
                                  <option value={location.name} disabled>
                                    {location.name} (currently selected)
                                  </option>
                                )}
                              </>
                            )}
                          </select>
                        </div>
                        <div className="p-2 border-b border-gray-200"></div>
                        <div className="p-2 border-b border-gray-200 flex items-center gap-2">
                          <input
                            min="0"
                            type="number"
                            value={location.value}
                            onChange={(e) => handleShipmentLocationChange(location.id, e.target.value)}
                            className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                            placeholder="0"
                          />
                          {shipmentLocations.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeShipmentLocation(location.id)}
                              className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition duration-200 text-xs"
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}

                  {/* Add More Button */}
                  <div className="flex justify-start mt-4">
                    <button
                      type="button"
                      onClick={addShipmentLocation}
                      className="flex items-center gap-2 px-3 py-2 bg-[#840028] text-white rounded hover:bg-[#6a0020] transition duration-200 text-sm"
                      disabled={loadingLocations || shipmentLocations.length >= locationOptions.length}
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      Add Another Location
                    </button>
                  </div>
                </div>
              </div>

              {/* Row 5 */}
              <div className="p-2 border-b border-gray-200">5.</div>
              <div className="p-2 border-b border-gray-200"># of Stamps destroyed by process (never a negative number)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">28.</div>
              <div className="p-2 border-b border-gray-200">
                <input
                  min="0"
                  type="number"
                  value={formData.stampsDestroyed}
                  onChange={(e) => handleInputChange('stampsDestroyed', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                />
              </div>

              {/* Row 6 */}
              <div className="p-2 border-b border-gray-200">6.</div>
              <div className="p-2 border-b border-gray-200">Adjustment (please explain)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">29.</div>
              <div className="p-2 border-b border-gray-200">
                <input
                  min="0"
                  type="number"
                  value={formData.adjustment}
                  onChange={(e) => handleInputChange('adjustment', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                />
              </div>

              {/* Row 7 */}
              <div className="p-2 border-b border-gray-200">7.</div>
              <div className="p-2 border-b border-gray-200">Total Stamps removed from Inventory (Line 4 + 5 + 6) or (ST Line 27+28+29)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">30.</div>
              <div className="p-2 border-b border-gray-200 bg-gray-50 text-right pr-3 text-sm">
                {formData.totalRemoved}
              </div>

              {/* Row 8 */}
              <div className="p-2 border-b border-gray-200">8.</div>
              <div className="p-2 border-b border-gray-200">"Calculated" End of Month Inventory of Un-affixed Stamps (Line 3 minus Line 7) (or ST line 26 minus 30)</div>
              <div className="p-2 border-b border-gray-200 text-center font-bold text-[#840028]">31.</div>
              <div className="p-2 border-b border-gray-200 bg-gray-50 text-right pr-3 text-sm">
                {formData.calculatedEndInventory}
              </div>
            </div>
          </div>
        </div>

        {/* Physical Inventory Section */}
        <div className="border border-gray-300 p-3 sm:p-4 mb-4 sm:mb-6 overflow-x-auto">
          <h2 className="text-lg font-bold mb-3 sm:mb-4 border-b border-[#840028] pb-2 text-[#840028]">
            Distributor "Actual" Physical un-affixed Stamp Inventory - Details
          </h2>

          <div className="min-w-[800px] sm:min-w-full">
            <div className="grid grid-cols-[auto,1fr,auto,auto,auto] gap-2 text-sm sm:text-base">
              {/* Header */}
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm"></div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm">a. Beginning Roll/Series #</div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm">b. Ending Roll/Series #</div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm"># of Stamps</div>
              <div className="font-bold bg-[#840028] text-white p-2 border-b border-[#840028] text-xs sm:text-sm"></div>

              {/* Row 9 */}
              <div className="p-2 border-b border-gray-200">9.</div>
              <div className="p-2 border-b border-gray-200">"Physical" End of the Month un-affixed Stamps - Full Rolls</div>
              <div className="p-2 border-b border-gray-200"></div>
              <div className="p-2 border-b border-gray-200"></div>
              <div className="p-2 border-b border-gray-200">
                <input
                  type="text"
                  value={formData.fullRolls}
                  readOnly
                  className="w-full px-2 py-1 border border-gray-300 rounded text-right bg-gray-50 text-sm"
                />
              </div>

              {/* Sub-rows 9.1, 9.2, 9.3 */}
              <div className="col-span-5 ml-4 sm:ml-8">
                <div className="grid grid-cols-[auto,1fr,auto,auto,auto] gap-2">
                  {/* 9.1 */}
                  <div className="p-2 border-b border-gray-200">9.1.</div>
                  <div className="p-2 border-b border-gray-200">First set "Full" Roll series #</div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.firstSetStart}
                      onChange={(e) => handleInputChange('firstSetStart', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                      placeholder="Set Start"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.firstSetEnd}
                      onChange={(e) => handleInputChange('firstSetEnd', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                      placeholder="Set End"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      type="text"
                      value={formData.firstSetFullRolls}
                      readOnly
                      className="w-full px-2 py-1 border border-gray-300 rounded text-right bg-gray-50 text-sm"
                    />
                    <span className="ml-2 text-xs sm:text-sm">Rolls</span>
                  </div>

                  {/* 9.2 */}
                  <div className="p-2 border-b border-gray-200">9.2.</div>
                  <div className="p-2 border-b border-gray-200">Second set "Full" Roll series #</div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.secondSetStart}
                      onChange={(e) => handleInputChange('secondSetStart', e.target.value)}
                      className="w-full text-right px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                      placeholder="Set Start"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.secondSetEnd}
                      onChange={(e) => handleInputChange('secondSetEnd', e.target.value)}
                      className="w-full px-2 py-1 text-right border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                      placeholder="Set End"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      type="text"
                      value={formData.secondSetFullRolls}
                      readOnly
                      className="w-full px-2 py-1 border border-gray-300 rounded text-right bg-gray-50 text-sm"
                    />
                    <span className="ml-2 text-xs sm:text-sm">Rolls</span>
                  </div>

                  {/* 9.3 */}
                  <div className="p-2 border-b border-gray-200">9.3</div>
                  <div className="p-2 border-b border-gray-200">Third set "Full" Roll series #</div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.thirdSetStart}
                      onChange={(e) => handleInputChange('thirdSetStart', e.target.value)}
                      className="text-right w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                      placeholder="Set Start"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.thirdSetEnd}
                      onChange={(e) => handleInputChange('thirdSetEnd', e.target.value)}
                      className="text-right w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                      placeholder="Set End"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      type="text"
                      value={formData.thirdSetFullRolls}
                      readOnly
                      className="w-full px-2 py-1 border border-gray-300 rounded text-right bg-gray-50 text-sm"
                    />
                    <span className="ml-2 text-xs sm:text-sm">Rolls</span>
                  </div>
                </div>
              </div>

              {/* Row 10 */}
              <div className="p-2 border-b border-gray-200">10.</div>
              <div className="p-2 border-b border-gray-200">"Physical" End of the Month un-affixed (New PBPN/KS) Stamps - Partial Roll Series #:</div>
              <div className="p-2 border-b border-gray-200"></div>
              <div className="p-2 border-b border-gray-200"></div>
              <div className="p-2 border-b border-gray-200">
                <input
                  type="text"
                  value={formData.partialRolls}
                  readOnly
                  className="w-full px-2 py-1 border border-gray-300 rounded text-right bg-gray-50 text-sm"
                />
              </div>

              {/* Partial Roll Details */}
              <div className="col-span-5 ml-4 sm:ml-8">
                <div className="grid grid-cols-[auto,1fr,auto,auto,auto] gap-2">
                  {/* Header for partial section */}
                  <div className="font-bold p-2"></div>
                  <div className="font-bold p-2 text-xs sm:text-sm"></div>
                  <div className="font-bold p-2">Roll #</div>
                  <div className="font-bold p-2 text-xs sm:text-sm"># of Stamps</div>
                  <div className="font-bold p-2"></div>

                  {/* 10.1 */}
                  <div className="p-2 border-b border-gray-200">10.1.</div>
                  <div className="p-2 border-b border-gray-200">First - "Partial" (New PBPN/KS) Roll series #</div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.firstPartialStart}
                      onChange={(e) => handleInputChange('firstPartialStart', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.firstPartialEnd}
                      onChange={(e) => handleInputChange('firstPartialEnd', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200"></div>

                  {/* 10.2 */}
                  <div className="p-2 border-b border-gray-200">10.2</div>
                  <div className="p-2 border-b border-gray-200">Second - "Partial" (New PBPN/KS) Roll series #</div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.secondPartialStart}
                      onChange={(e) => handleInputChange('secondPartialStart', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.secondPartialEnd}
                      onChange={(e) => handleInputChange('secondPartialEnd', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200"></div>

                  {/* 10.3 */}
                  <div className="p-2 border-b border-gray-200">10.3</div>
                  <div className="p-2 border-b border-gray-200">Third - "Partial" (New PBPN/KS) Roll series #</div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.thirdPartialStart}
                      onChange={(e) => handleInputChange('thirdPartialStart', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.thirdPartialEnd}
                      onChange={(e) => handleInputChange('thirdPartialEnd', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm text-right"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200"></div>

                  {/* 10.4 */}
                  <div className="p-2 border-b border-gray-200">10.4</div>
                  <div className="p-2 border-b border-gray-200">End of Roll loose pieces - Hand Counted Stamps</div>
                  <div className="p-2 border-b border-gray-200"></div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.looseStamps}
                      onChange={(e) => handleInputChange('looseStamps', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200"></div>

                  {/* 10.5 */}
                  <div className="p-2 border-b border-gray-200">10.5</div>
                  <div className="p-2 border-b border-gray-200">Positive Variance: Stamps Removed from inventory and Returned to PBPN (Stamps must be cut off from Partial roll and returned to PBPN by the 15th)</div>
                  <div className="p-2 border-b border-gray-200"></div>
                  <div className="p-2 border-b border-gray-200">
                    <input
                      min="0"
                      type="number"
                      value={formData.positiveVariance}
                      onChange={(e) => handleInputChange('positiveVariance', e.target.value)}
                      className="w-full px-2 py-1 border border-gray-300 rounded text-right focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm"
                    />
                  </div>
                  <div className="p-2 border-b border-gray-200"></div>
                </div>
              </div>

              {/* Row 11 */}
              <div className="p-2 border-b border-gray-200">11.</div>
              <div className="p-2 border-b border-gray-200">"Physical" End of Month Total # un-Affixed Stamps in inventory:</div>
              <div className="p-2 border-b border-gray-200"></div>
              <div className="p-2 border-b border-gray-200"></div>
              <div className="p-2 border-b border-gray-200">
                <input
                  type="text"
                  value={formData.physicalEndTotal}
                  readOnly
                  className="w-full px-2 py-1 border border-gray-300 rounded text-right bg-gray-50 text-sm"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Variance Section */}
        <div className="border border-gray-300 p-3 sm:p-4 mb-4 sm:mb-6">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 mb-4">
            <div className="font-bold text-[#840028] text-sm sm:text-base">Variances MUST be Zeroed out. Enter Negative Variances in Line 5 and Enter Positive Variances in Line 10.5.</div>
            <div className="text-red-500 font-bold text-sm sm:text-base">{formData.variance}</div>
          </div>

          <div className="bg-gray-50 p-3 sm:p-4 border border-gray-200 mb-4 text-sm">
            <p className="mb-2">Positive means some packs did not get stamped or part of the order was stamped by someone else's stamp</p>
            <p>Negative means some stamps are returned, missing or damaged that was not reported on line 5 above or were affixed to someone else's order.</p>
          </div>

          <div className="mb-4">
            <label className="font-bold block mb-2 text-[#840028] text-sm sm:text-base">
              Explain in the Green box below the reason for the variance in Un-Affixed Physical Inventory:
              {isVarianceExplanationRequired && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            <textarea
              value={formData.varianceExplanation}
              onChange={(e) => handleInputChange('varianceExplanation', e.target.value)}
              rows="4"
              className={`w-full p-3 border-2 rounded-lg bg-green-50 resize-y focus:border-[#840028] focus:ring-1 focus:ring-[#840028] text-sm ${isVarianceExplanationRequired && !formData.varianceExplanation.trim()
                ? 'border-red-500'
                : 'border-green-500'
                }`}
              placeholder={
                isVarianceExplanationRequired
                  ? "Variance explanation is required..."
                  : "Enter variance explanation if applicable..."
              }
              required={isVarianceExplanationRequired}
            />
            {isVarianceExplanationRequired && !formData.varianceExplanation.trim() && (
              <p className="text-red-500 text-sm mt-1">
                Variance explanation is required when there is a variance.
              </p>
            )}
          </div>
        </div>

        {/* Supporting Documents (Optional) */}
        <div className="border border-gray-300 p-4 sm:p-6 mb-4 sm:mb-6 rounded-lg bg-white">
          <h3 className="text-lg font-bold mb-3 sm:mb-4 text-center text-[#840028]">
            Supporting Documents (Optional)
          </h3>
          <p className="text-sm text-gray-700 mb-3 text-center">
            You may upload one or more files to support this report. This step is optional.
          </p>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Files:
            </label>
            <input
              type="file"
              multiple
              onChange={handleAttachmentChange}
              className="block w-full text-sm text-gray-700
                         file:mr-4 file:py-2 file:px-4
                         file:rounded-md file:border-0
                         file:text-sm file:font-semibold
                         file:bg-[#840028] file:text-white
                         hover:file:bg-[#6a0020]"
            />
            {attachments && attachments.length > 0 && (
              <div className="mt-3">
                <p className="text-sm font-medium text-gray-700 mb-1">Selected files:</p>
                <ul className="space-y-2 text-xs text-gray-700">
                  {attachments.map((file, index) => (
                    <li
                      key={`${file.name}-${index}`}
                      className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded px-2 py-1"
                    >
                      <span className="truncate mr-2">{file.name}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveAttachment(index)}
                        className="text-red-600 hover:text-red-800 text-[11px] font-semibold"
                      >
                        Delete
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Signature Section */}
        <div className="border border-gray-300 p-4 sm:p-6 mb-4 sm:mb-6">
          <h3 className="text-lg font-bold mb-3 sm:mb-4 text-center text-[#840028]">Signature</h3>

          <div className="mb-4">
            <label className="font-bold block mb-2 text-[#840028] text-sm sm:text-base">
              Sign below to certify the accuracy of this report:
            </label>
            <div
              id="signature-container"
              className="border-2 border-gray-300 rounded-lg p-3 sm:p-4 bg-white"
            >
              {canvasSize.width > 0 && (
                <SignatureCanvas
                  ref={sigCanvas}
                  penColor="#0000FF"
                  backgroundColor="rgb(255, 255, 255)"
                  canvasProps={{
                    width: canvasSize.width,
                    height: canvasSize.height,
                    className: 'signature-canvas w-full border border-gray-400 rounded bg-white cursor-crosshair'
                  }}
                  onBegin={handleSignatureBegin}
                  onEnd={handleSignatureEnd}
                  clearOnResize={false}
                />
              )}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
            <div className="text-sm text-gray-600 text-center sm:text-left">
              {isSigned ? (
                <span className="text-green-600 font-bold">✓ Signature provided</span>
              ) : (
                <span className="text-red-600">Please sign above</span>
              )}
            </div>

            <button
              type="button"
              onClick={clearSignature}
              className="px-4 py-2 bg-[#840028] text-white rounded hover:bg-[#6a0020] transition duration-200 text-sm"
            >
              Clear Signature
            </button>
          </div>

          {/* Printed Name and Title Fields - Added */}
          <div className="border-t pt-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Printed Name: <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={printedName}
                  onChange={(e) => setPrintedName(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="Enter your full name"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Title: <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="Enter your title"
                  required
                />
              </div>
            </div>

            {/* Date Field */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date Signed:
              </label>
              <input
                type="text"
                value={currentDate}
                readOnly
                className="w-full sm:w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 font-medium text-gray-700 cursor-not-allowed text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">
                This date is automatically set to today's date and cannot be modified
              </p>
            </div>
          </div>
        </div>

        {/* Certification */}
        <div className="border-t-2 border-b-2 border-[#840028] py-4 sm:py-6 my-6 sm:my-8 text-center italic text-[#840028] text-sm sm:text-base">
          <p>
            I certify that I am a duly authorized owner, partner, director, officer or representative of the licensee and that the statements made herein are true and correct to the best of my knowledge.
          </p>
        </div>

        <div className="text-center">
          <button
            type="submit"
            disabled={!isSigned || isSubmitting || !printedName.trim() || !title.trim()}
            className="bg-[#840028] hover:bg-[#6a0020] text-white font-bold py-3 px-6 sm:px-8 rounded-lg transition duration-200 disabled:bg-gray-400 disabled:cursor-not-allowed w-full sm:w-auto text-sm sm:text-base"
          >
            {isSubmitting ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Submitting...
              </span>
            ) : (
              isSigned && printedName.trim() && title.trim() ? 'Submit Report' : 'Please Complete All Required Fields'
            )}
          </button>
        </div>
      </form>

      {/* Custom CSS for signature canvas */}
      <style jsx>{`
        .signature-canvas {
          cursor: crosshair !important;
          touch-action: none;
        }
        .signature-canvas:active {
          cursor: grabbing !important;
        }
        #signature-container {
          min-height: 200px;
        }
        
        @media (max-width: 640px) {
          #signature-container {
            min-height: 150px;
          }
        }
      `}</style>
    </div>
  );
};

export default StampsInventory;